import type { Source } from "@bios/types";

const BASE = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "http://localhost:8787";

export class AdminApi {
  constructor(private getToken: () => Promise<string | null>) {}

  private async request<T>(path: string, init?: RequestInit): Promise<T> {
    const token = await this.getToken();
    const res = await fetch(`${BASE}${path}`, {
      ...init,
      headers: {
        ...(init?.headers ?? {}),
        ...(token ? { authorization: `Bearer ${token}` } : {}),
        ...(init?.body ? { "content-type": "application/json" } : {}),
      },
    });
    if (!res.ok) {
      const detail = await res.text().catch(() => "");
      throw new Error(`api_${res.status}: ${detail}`);
    }
    return (await res.json()) as T;
  }

  sources() {
    return this.request<{ sources: Source[] }>(`/v1/sources`);
  }
  createSource(body: Partial<Source>) {
    return this.request<{ source: Source }>(`/v1/sources`, {
      method: "POST",
      body: JSON.stringify(body),
    });
  }
  updateSource(id: string, body: Partial<Source>) {
    return this.request<{ source: Source }>(`/v1/sources/${id}`, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  }
  deleteSource(id: string) {
    return this.request<{ ok: true }>(`/v1/sources/${id}`, { method: "DELETE" });
  }
  triggerSource(id: string) {
    return this.request<{ ok: true }>(`/v1/sources/${id}/trigger`, { method: "POST" });
  }
}
